export default function FeaturesSection() {
  const features = [
    {
      icon: 'ri-arrow-down-double-line',
      title: '下拉式阅读',
      desc: '专为网页端优化的下拉式阅读体验，无需翻页点击，流畅顺滑，完美适配手机与电脑。',
      color: 'bg-primary-100 text-primary-600',
    },
    {
      icon: 'ri-file-list-3-line',
      title: '完整无删减',
      desc: '所有韩国漫画均为完整版无删减资源，保持原作原汁原味的剧情与画面，让您看到最真实的内容。',
      color: 'bg-accent-100 text-accent-600',
    },
    {
      icon: 'ri-coins-line',
      title: '完全免费',
      desc: '无需付费订阅，无需购买会员，打开即可免费阅读海量韩国漫画，没有任何隐藏收费。',
      color: 'bg-secondary-100 text-secondary-600',
    },
    {
      icon: 'ri-rocket-line',
      title: '极速更新',
      desc: '与韩国漫画源同步更新，热门连载作品24小时内提供中文翻译，追漫不等待。',
      color: 'bg-primary-100 text-primary-600',
    },
    {
      icon: 'ri-image-line',
      title: '高清画质',
      desc: '所有漫画资源均提供高清画质版本，色彩还原真实，细节清晰可见，阅读体验极佳。',
      color: 'bg-accent-100 text-accent-600',
    },
    {
      icon: 'ri-device-line',
      title: '多端适配',
      desc: '完美支持电脑、平板、手机等多设备访问，响应式设计确保在任何设备上都有舒适的阅读体验。',
      color: 'bg-secondary-100 text-secondary-600',
    },
  ];

  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-2xl font-heading text-foreground-900 mb-2">为什么选择虫虫漫画网</h2>
          <p className="text-sm text-foreground-500 max-w-xl mx-auto">
            六大核心优势，让您体验最纯粹的韩国漫画阅读
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {features.map((feature) => (
            <div key={feature.title} className="bg-background-50 rounded-lg p-5 hover:shadow-sm transition-shadow">
              <div className={`w-12 h-12 flex items-center justify-center rounded-lg mb-4 ${feature.color}`}>
                <i className={`${feature.icon} text-xl`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-2">{feature.title}</h3>
              <p className="text-xs text-foreground-600 leading-relaxed">{feature.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}